export default __webpack_public_path__ + "static/media/Dazzed-Regular.c68a4c8b.woff2";